module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section05_04_american-village-99b4147f02c1db46d8d92b01399db3db.jpg";